import dayjs from 'dayjs';

export const getDayJsDate = (date: string) => {
  return date ? dayjs(date) : null;
};
